export interface PurchaseOrderLineProduct {
  productId: string;
  productKey: string;
  productDescription: string;
  supplierReference: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  conversionUomId: string;
  currencyCode: string;
  standardRollLength: number;
  minimumOrderQuantity: number;
  deliveryDate: Date;
  showNoOfItemsOnPurchaseOrder: boolean;
  holdStockAtProductLevel: boolean;
  workOutQuantityFromItemsPurchaseOrder: boolean;
  fabricSpecComments: string;
}
